import { JSONSchema7 } from "json-schema";

export const ExplainCustomizeFeedMetadataSchema: JSONSchema7 = {
  description: "Customize feed explanation.",
  type: "object",
  $schema: "http://json-schema.org/draft-07/schema#",
};
